export const blockIconsMapsMenuBook = (
	<span className='material-symbols-outlined'>menu_book</span>
);
